angular.module('iconoglobe').directive('ngTranslateLanguageSelect', function (LocaleService, LOCALES, $document) {
    'use strict';
    return {
        restrict: 'A',
        replace: true,
        scope: true,
        template: [
            '<div class="language-select select-box ig-language" ng-show="visible" ng-click="$event.stopPropagation()">',
              '<div class="ig-lang-desktop">',
                '<select class="lang-select" ng-model="currentLocaleDisplayName" ',
                  'ng-options="locale[0] for locale in localesDisplayNames" ',
                  'ng-change="changeLanguage(currentLocaleDisplayName)"></select>',
              '</div>',
              '<div class="ig-lang-mobile">',
                '<button type="button" class="ig-lang-trigger" ng-click="toggleLanguages($event)" ',
                    'ng-attr-aria-expanded="{{languageOpen}}" aria-haspopup="listbox" aria-label="Select language">',
                  '<span class="ig-lang-name">{{currentLocaleDisplayName[0]}}</span>',
                  '<span class="ig-lang-arrow" ng-class="{open: languageOpen}" aria-hidden="true"></span>',
                '</button>',
                '<div class="ig-lang-options" ng-show="languageOpen" role="listbox" aria-label="Choose language">',
                  '<button type="button" class="ig-lang-option" ng-repeat="locale in localesDisplayNames track by $index" ',
                     'ng-class="{selected: locale[0] === currentLocaleDisplayName[0]}" ',
                     'ng-click="selectLanguage(locale, $event)">',
                    '<span>{{locale[0]}}</span><span class="ig-lang-check" ng-if="locale[0] === currentLocaleDisplayName[0]">✓</span>',
                  '</button>',
                '</div>',
              '</div>',
            '</div>'
        ].join(''),
        controller: function ($scope, cookieStore) {
            $scope.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();
            $scope.localesDisplayNames = LocaleService.getLocalesDisplayNames();
            $scope.visible = !!($scope.localesDisplayNames && $scope.localesDisplayNames.length > 1);
            $scope.languageOpen = false;
            $scope.toggleLanguages = function ($event) {
                $event.stopPropagation();
                $scope.languageOpen = !$scope.languageOpen;
            };
            $scope.changeLanguage = function (locale) {
                if (!locale) return;
                LocaleService.setLocaleByDisplayName(locale);
                angular.forEach(LOCALES.locales, function (value, key) {
                    if (value[0] === locale[0]) {
                        cookieStore.setCookie('lang_pref', key);
                        window.location.href = value[1];
                    }
                });
            };
            $scope.selectLanguage = function (locale, $event) {
                $event.stopPropagation();
                $scope.languageOpen = false;
                if (!locale) return;
                if ($scope.currentLocaleDisplayName && locale[0] === $scope.currentLocaleDisplayName[0]) return;
                $scope.currentLocaleDisplayName = locale;
                $scope.changeLanguage(locale);
            };
            function closeOnOutsideClick() {
                $scope.$evalAsync(function () { $scope.languageOpen = false; });
            }
            $document.on('click', closeOnOutsideClick);
            $scope.$on('$destroy', function () { $document.off('click', closeOnOutsideClick); });
        }
    };
});
